import { KeyboardEvent } from "react";
import { useNavigate } from "react-router-dom";
import SectionHeading from "../../components/Typography/SectionHeading";
import { articles, generateSlug } from "./articles";
import "../../components/PortfolioCard/index.css";

function ArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}

function Blog() {
  const navigate = useNavigate();

  const handleCardClick = (title: string) => {
    navigate(`/blog/${generateSlug(title)}`);
  };

  const handleKeyDown = (
    event: KeyboardEvent<HTMLElement>,
    title: string
  ) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleCardClick(title);
    }
  };

  return (
    <section className="container pt-16 tablet:py-0">
      <SectionHeading text="Blog" />

      <div className="portfolio-page__grid">
        {articles.map((article) => (
          <article
            key={article.title}
            className="portfolio-card group cursor-pointer"
            onClick={() => handleCardClick(article.title)}
            onKeyDown={(event) => handleKeyDown(event, article.title)}
            role="link"
            tabIndex={0}
            aria-label={`Read article: ${article.title}`}
          >
            {article.image && (
              <div className="portfolio-card__image">
                <img
                  src={article.image}
                  alt={article.title}
                  loading="lazy"
                />
              </div>
            )}

            <div className="portfolio-card__body">
              <span className="portfolio-card__category">
                {article.category ?? "Article"}
              </span>
              <h3 className="portfolio-card__title">{article.title}</h3>
              <p className="portfolio-card__description">{article.body}</p>
              <span className="portfolio-card__link">
                Read article
                <ArrowIcon />
              </span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Blog;
